import Swiper, { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", function () {
	/* Why Word Cards Slider */

	var swiper = Swiper;
	var init = false;

	function serviceCards() {
		if (window.innerWidth <= 1320) {
			if (!init) {
				init = true;
				swiper = new Swiper("#candidateServicesSwiper", {
					direction: "horizontal",
					slidesPerView: 1.25,
					spaceBetween: 10,

					breakpoints: {
						650: {
							slidesPerView: 2.2,
							spaceBetween: 20,
						},
						1024: {
							slidesPerView: 2.8,
							spaceBetween: 20,
						},
					},
				});
			}
		} else if (init) {
			swiper.destroy();
			init = false;
		}
	}
	serviceCards();
	window.addEventListener("resize", serviceCards);

	/* Process Slider */
	function processSlider() {
		const processSlider = new Swiper("#processSlider", {
			modules: [Navigation],
			direction: "horizontal",
			slidesPerView: 1.5,
			spaceBetween: 15,

			breakpoints: {
				750: {
					slidesPerView: 2.4,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 1.8,
					spaceBetween: 20,
				},
				1340: {
					slidesPerView: 3.2,
					spaceBetween: 20,
				},
				1920: {
					slidesPerView: 3.6,
					spaceBetween: 20,
				},
			},

			navigation: {
				nextEl: "#nextBtn",
				prevEl: "#prevBtn",
			},
		});
	}
	processSlider();
	window.addEventListener("resize", processSlider);

	/**
	 * Resource Links Accordion
	 */

	let accordionBtns = document.getElementsByClassName(
		"candidate__resources-list-button"
	);
	let accordionPanels = document.getElementsByClassName(
		"candidate__resources-list-panel"
	);

	for (let i = 0; i < accordionBtns.length; i++) {
		let element = accordionBtns[i];

		element.addEventListener("click", (e) => {
			console.log(e.target);

			if (element.classList.contains("open")) {
				element.classList.toggle("open");
				element.nextElementSibling.style.maxHeight = 0;
			} else {
				[...accordionBtns].forEach((btn) => {
					btn.classList.remove("open");
				});

				[...accordionPanels].forEach((panel) => {
					panel.style.maxHeight = 0;
				});
			}

			element.classList.toggle("open");
			element.nextElementSibling.style.maxHeight =
				element.nextElementSibling.scrollHeight + "px";
		});
	}

	/**
	 * WHY WORK CARDS ANIMATION
	 */
	if (window.innerWidth >= 1024) {
		var workCardAnim = gsap.timeline();
		workCardAnim.fromTo(
			".services__work-cards .card",
			{ y: 30, autoAlpha: 0 },
			{ y: 0, autoAlpha: 1, duration: 1, stagger: 0.5, ease: "ease" }
		);
		ScrollTrigger.create({
			start: "top 75%",
			end: "bottom 50%",
			trigger: ".services__work",
			animation: workCardAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});

		/**
		 * Candidate Package Section Animation
		 */

		var packageSectionAnim = gsap.timeline();
		packageSectionAnim.fromTo(
			".candidate__package-content .image",
			{ x: 30, autoAlpha: 0 },
			{ x: 0, autoAlpha: 1, duration: 1 }
		);

		ScrollTrigger.create({
			start: "top 50%",
			end: "bottom 50%",
			trigger: ".candidate__package",
			animation: packageSectionAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});

		/**
		 * Candidate Support Section Animation
		 */

		var supportSectionAnim = gsap.timeline();
		supportSectionAnim
			.fromTo(
				".candidate__support-content .text .title",
				{ x: 30, autoAlpha: 0 },
				{ x: 0, autoAlpha: 1, duration: 1 }
			)
			.fromTo(
				".candidate__support-content .text .content",
				{ x: 30, autoAlpha: 0 },
				{ x: 0, autoAlpha: 1, duration: 1 },
				"<=0.3"
			)
			.fromTo(
				".candidate__support-content .text .name",
				{ x: 30, autoAlpha: 0 },
				{ x: 0, autoAlpha: 1, duration: 1 },
				"<=0.2"
			)
			.fromTo(
				".candidate__support-content .text .role",
				{ x: 30, autoAlpha: 0 },
				{ x: 0, autoAlpha: 1, duration: 1 },
				"<=0.3"
			);

		ScrollTrigger.create({
			start: "top 75%",
			end: "bottom 50%",
			trigger: ".candidate__support",
			animation: supportSectionAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});

		/**
		 * Candidate Cards Animation
		 */

		var canTwoCardsAnim = gsap.timeline();
		canTwoCardsAnim.fromTo(
			".candidate__two-cards .inner .card",
			{ y: 30, autoAlpha: 0 },
			{ y: 0, autoAlpha: 1, duration: 1, stagger: 0.5, ease: "ease" }
		);

		ScrollTrigger.create({
			start: "top 50%",
			end: "bottom 50%",
			trigger: ".candidate__two-cards",
			animation: canTwoCardsAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});

		/**
		 * Candidate Process Slider Animation
		 */

		var processSliderAnim = gsap.timeline();
		processSliderAnim.fromTo(
			".candidate__process-slider .swiper-slide",
			{ y: 30, autoAlpha: 0 },
			{ y: 0, autoAlpha: 1, duration: 1, stagger: 0.5, ease: "ease" }
		);

		ScrollTrigger.create({
			start: "top 75%",
			end: "bottom 50%",
			trigger: ".candidate__process-slider",
			animation: processSliderAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});

		/**
		 * Candidate Criteria Section Animation
		 */

		var criteriaSectionAnim = gsap.timeline();
		criteriaSectionAnim.fromTo(
			".candidate__criteria-image",
			{ x: 30, autoAlpha: 0 },
			{ x: 0, autoAlpha: 1, duration: 1 }
		);

		ScrollTrigger.create({
			start: "top 75%",
			end: "bottom 50%",
			trigger: ".candidate__criteria",
			animation: criteriaSectionAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});

		/**
		 * Candidate Cards & Text Animation
		 */

		var textCardsAnim = gsap.timeline();
		textCardsAnim
			.fromTo(
				".candidate__two-cards-text .intro h2",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 1 }
			)
			.fromTo(
				".candidate__two-cards-text .intro div",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 1 },
				"<=0.3"
			)
			.fromTo(
				".candidate__two-cards-text .cards",
				{ y: 30, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 1 },
				"<=0.2"
			);

		ScrollTrigger.create({
			start: "top 50%",
			end: "bottom 50%",
			trigger: ".candidate__two-cards-text",
			animation: textCardsAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});
	}
});
